
import * as ReactDOM from 'react-dom';

export type Hydrate = typeof ReactDOM.hydrate;

export const hydrate = ReactDOM.hydrate;